<template>
  <div>TrangSuaChucVu</div>
</template>

<script>
export default {
  name: "TrangSuaChucVu"
};
</script>


